import { usePasswordStrengthBar } from "@hooks/usePasswordStrengthBar";
import { Progress } from "@kirvanobr/progress";
import { Typography } from "@kirvanobr/typography";
import { styles as s } from "./PasswordStrengthBar.styles";
import { PasswordStrengthBarProps } from "./PasswordStrengthBar.types";

export function PasswordStrengthBar({ password, isHidden = false }: PasswordStrengthBarProps) {
  const { passwordStrengthLevel, passwordStrengthTitle, passwordStrengthColor } = usePasswordStrengthBar(password);

  return (
    <div className={s().base({ isHidden })}>
      <Progress size="md" value={passwordStrengthLevel(password) * 20} color={passwordStrengthColor()} />
      {!!passwordStrengthTitle().length && (
        <Typography
          variant="subtitle"
          size="t4"
          weight="bold"
          className={s().passwordStrengthText({ color: passwordStrengthColor() })}
        >
          {passwordStrengthTitle()}
        </Typography>
      )}
    </div>
  );
}
